import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static override targets = ["popover", "selectedOptionInput", "fromDateInput", "toDateInput"];

    declare popoverTarget: HTMLElement;
    declare selectedOptionInputTarget: HTMLInputElement;
    declare fromDateInputTarget: HTMLInputElement;
    declare toDateInputTarget: HTMLInputElement;

    public get selectedOption() {
        return this.selectedOptionInputTarget.value;
    }

    public get fromDate() {
        return this.fromDateInputTarget.value;
    }

    public get toDate() {
        return this.toDateInputTarget.value;
    }

    public override connect(): void {
    }

    public selectOption(event: Event) {
        const target = event.target as HTMLInputElement;
        this.selectedOptionInputTarget.value = target.value;

        if (target.value !== "Custom") {
            this.fromDateInputTarget.value = '';
            this.toDateInputTarget.value = '';
            this.selectedOptionInputTarget.dispatchEvent(new Event('change', {bubbles: true}));
        }
    }

    public updateFromDate(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fromDateInputTarget.value = target.value;

        if (this.fromDate && this.toDate) {
            this.fromDateInputTarget.dispatchEvent(new Event('change', {bubbles: true}));
        }
    }

    public updateToDate(event: Event) {
        const target = event.target as HTMLInputElement;
        this.toDateInputTarget.value = target.value;
        
        if (this.fromDate && this.toDate) {
            this.toDateInputTarget.dispatchEvent(new Event('change', {bubbles: true}));
        }
    }
}